
import Phone from '../assets/iphone.svg';
import Paper from '../assets/background-paper.png';
import Paper2 from '../assets/background-paper2.png';
import './rotationMobile.css';
import './animate.css';

import ImageSequenceComponent from './imagesequence';
import Reveal1 from '../assets/reveal-transition-1.png';
import Reveal2 from '../assets/reveal-transition-2.png';
import Reveal3 from '../assets/reveal-transition-3.png';
import Reveal4 from '../assets/reveal-transition-4.png';
import Reveal5 from '../assets/reveal-transition-5.png';
import Reveal6 from '../assets/reveal-transition-6.png';

function RotationMobile() {

    var images = [
        Reveal1,
        Reveal2,
        Reveal3,
        Reveal4,
        Reveal5,
        Reveal6
    ];

    return (
        <div className="rotationMobile">
            
            <div className="containerMobile">
                <div className="spacer" style={{ backgroundImage: 'url(' + Paper + ')' }}></div>
                <div className="spacer2" style={{ backgroundImage: 'url(' + Paper2 + ')' }}></div>
                <div className="rotating-image-container popIn">
                    <div className="rotating-image">
                        <ImageSequenceComponent shouldChange={true} imageSet={images} alternateImageSet={images.slice().reverse()} useAlternateSet={false}/>

                        <img src={ Phone } alt="Rotating" className="frame" />
                    </div>
                    
                </div>
                
            </div>
        </div>
    );
}

export default RotationMobile;
